import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store'
import helper from './helper'
import Multiselect from 'vue-multiselect'
import '@/assets/css/multiselect-bs4.css'

/// ===== LOCAL DEV
// const BASE_API_PATH = "https://api.pugindo.sm.inergi.id/api/"
// const BASE_FILE_PATH = "https://api.pugindo.sm.inergi.id"
// const BASE_PRINT_FILE_PATH = "https://api.pugindo.sm.inergi.id"

/// ===== PRODUCTION
const BASE_API_PATH = "https://ignis.penjualan.pugindo.com/api/"
const BASE_FILE_PATH = "https://sinarmutiaracell.sgp1.digitaloceanspaces.com"
const BASE_PRINT_FILE_PATH = "https://ignis.penjualan.pugindo.com"

/// ===== LOCAL DEV WANDY
// const BASE_API_PATH = "http://10.10.131.108:8000/api/"
// const BASE_FILE_PATH = "http://10.10.131.108:8000"
// const BASE_PRINT_FILE_PATH = "http://10.10.131.108:8000"

// const BASE_API_PATH = "http://localhost:8000/api/"
// const BASE_FILE_PATH = "http://localhost:8000"
// const BASE_PRINT_FILE_PATH = "http://localhost:8000"

// DEV
// const BASE_API_PATH = "https://api.sm-penjualan-dev.pgindonesia.com/api/";
// const BASE_FILE_PATH = "https://sm-dev.sgp1.digitaloceanspaces.com";
// const BASE_PRINT_FILE_PATH = "https://api.sm-penjualan-dev.pgindonesia.com";


axios.defaults.baseURL = BASE_API_PATH
axios.defaults.timeout = 180000
axios.defaults.headers.post['Accept'] = 'application/json'
axios.defaults.headers.common['Authorization'] = localStorage.getItem("token-katalog") || ""
axios.defaults.headers.common['LoginTime'] = localStorage.getItem("loginTime") || ""

// Interceptors for 401 responses (unauthorized)
axios.interceptors.response.use(function(response) {
    return response
}, function (error) {

    console.log(error.response)

    if(error.response && error.response.status == 401) {

        axios.defaults.headers.common['Authorization'] = ""
        var version = localStorage.getItem("version")
        localStorage.clear()
        localStorage.setItem("version", version)

        if(router.currentRoute.path != '/katalog'){
            router.push("/katalog")
        } else {
            router.go()
        }

    } else if(error.response && error.response.status == 402) {

        axios.defaults.headers.common['Authorization'] = ""
        var version = localStorage.getItem("version")
        localStorage.clear()
        localStorage.setItem("version", version)

        if(router.currentRoute.path != '/katalog'){
            router.push("/katalog")
        } else {
            router.go()
        }

    }

    return Promise.reject(error)

})

Vue.use(BootstrapVue)
Vue.component('multiselect', Multiselect)
Vue.prototype.$axios = axios
Vue.prototype.$helper = helper
Vue.prototype.$BASE_FILE_PATH = BASE_FILE_PATH
Vue.prototype.$BASE_PRINT_FILE_PATH = BASE_PRINT_FILE_PATH

/// GLOBAL COMPONENTS
/// Base components
const requireComponent = require.context('./globals', false, /[A-Z]\w+\.(vue|js)$/)

requireComponent.keys().forEach(fileName => {

    const componentConfig = requireComponent(fileName)
    let compName = fileName.includes("Loading") ? "LoadingWidget" : "PageSizer"

    Vue.component(compName, componentConfig.default || componentConfig)

})

new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {
        App
    }
})
